module.exports = __webpack_public_path__ + "static/outdoor-category-c552cf2d4902791ea520cf6dd07243d0.png";